import React, {Component} from "react";
import {FaDatabase} from 'react-icons/fa/index.esm';

export  class Database extends Component {
    render() {
        return <><FaDatabase/></>;
    }
}